<!-- 材积计算 -->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <el-row v-for="(volumn, idx) in form.volumns" :key="idx">
        <el-col :xs="24" :sm="12" style="padding:15px;">
          <el-link style="margin-top:8px;" type="danger" disabled>
            {{ msg('注：输入长宽高尺寸按立方货形计算；只输入长宽尺寸为扁平货形计算；只输入长度为条、柱状货形计算；') }}
          </el-link>
        </el-col>
        <el-col :xs="24" style="padding:15px;">
          <el-input v-model="volumn.volumn1" style="width:300px;" size="mini">
            <template slot="prepend">{{ "立方货形 = " }}</template>
          </el-input>
        </el-col>
        <el-col :xs="24" style="padding:15px;">
          <el-input v-model="volumn.volumn2" style="width:300px;" size="mini">
            <template slot="prepend">{{ "扁平货形 = " }}</template>
          </el-input>
        </el-col>
        <el-col :xs="24" style="padding:15px;">
          <el-input v-model="volumn.volumn3" style="width:300px;" size="mini">
            <template slot="prepend">{{ "条柱货形 =" }}</template>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingMeasurement",
  data() {
    return {
      xgroup: 'VOLUMN_FORMULA',  //电子秤group
      form: {
        volumns: [],//材积计算
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.volumns = [];

      let volumns = data; //材积计算
      //材积计算
      if (volumns.length > 0) {
        volumns.forEach(a => {
          if (a.xvalue) {
            let ws = JSON.parse(a.xvalue);
            let volumn1 = ws.volumn1;
            let volumn2 = ws.volumn2;
            let volumn3 = ws.volumn3;
            let warn = {
              id: a.id,
              volumn1: volumn1,
              volumn2: volumn2,
              volumn3: volumn3,
              owner: a.owner,
            }
            _this.form.volumns.push(warn);
          }
        })
      } else {
        _this.form.volumns.push({
          id: null,
          xkey: 'VOLUMN_FORMULA',
          owner: null,
          xgroup: 'VOLUMN_FORMULA',
          volumn1: '长*宽*高/27000',
          volumn2: '长*宽/900',
          volumn3: '长/30',
          xtype: 1
          // xvalue: JSON.stringify({
          //     volumn1: '长*宽*高/27000',
          //     volumn2: '长*宽/900',
          //     volumn3: '长/30'
          // }),
        })
      }
    },
    update() {
      let datas = [];
      //构建材积计算
      for (let i = 0; i < this.form.volumns.length; i++) {
        let volumn = this.form.volumns[i];
        let key = this.xgroup;

        let volumn1 = volumn.volumn1;
        let volumn2 = volumn.volumn2;
        let volumn3 = volumn.volumn3;

        datas.push({
          id: volumn.id,
          xkey: key,
          owner: volumn.owner ? volumn.owner : null,
          xgroup: key,
          xvalue: JSON.stringify({
            volumn1: volumn1,
            volumn2: volumn2,
            volumn3: volumn3
          }),
        });
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>